// Baz Skills Integration Configuration
/**
 * Default page size for paginated requests
 */
export const BAZ_DEFAULT_PAGE_SIZE = 20;
/**
 * Available skill categories
 */
export const BAZ_SKILL_CATEGORIES = [
    'productivity',
    'development',
    'data-analysis',
    'communication',
    'automation',
    'security',
    'monitoring',
    'integration',
    'utility',
    'other',
];
/**
 * Sort options for skill listings
 */
export const BAZ_SORT_OPTIONS = [
    { value: 'popularity', label: 'Most Popular' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'recent', label: 'Recently Updated' },
    { value: 'name', label: 'Name (A-Z)' },
];
/**
 * Model recommendations for Baz agents
 */
export const BAZ_RECOMMENDED_MODELS = [
    'gpt-4',
    'gpt-4-turbo',
    'gpt-3.5-turbo',
    'claude-3-opus',
    'claude-3-sonnet',
    'claude-3-haiku',
];
/**
 * Status badge colors for different states
 */
export const BAZ_STATUS_COLORS = {
    active: 'success',
    inactive: 'warning',
    error: 'error',
    healthy: 'success',
    degraded: 'warning',
    down: 'error',
};
